import React from 'react';
import styled from 'styled-components';
import { AIReview } from '../../../common/models/types';
import { AIReviewEvaluation } from '../../../types/aiReviewTest';
import AIReviewDetailTemplate from '../AIReviewDetailTemplate';
import { SlideManager } from '../../organisms/CommonUI/SlidePopup/SlideManager';
import AIReviewDetailAdminViewerTemplate from '../AIReviewDetailTemplate/AdminViewer';
import { AdminFeedbackProvider } from '../../../contexts/FeedbackContext';

const PopupContainer = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
`;

const Header = styled.div`
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h2`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 16px;
  color: #666;
  cursor: pointer;
  padding: 2px;
  
  &:hover {
    color: #333;
  }
`;

const ContentWrapper = styled.div`
  height: calc(100vh - 40px);
  overflow-y: auto;
  padding: 8px;
`;

interface AdminAIReviewDetailPopupTemplateProps {
  review: AIReview;
  evaluation?: AIReviewEvaluation | null;
}

const AdminAIReviewDetailPopupTemplate: React.FC<AdminAIReviewDetailPopupTemplateProps> = ({ review, evaluation }) => {
  const handleClose = () => {
    window.close();
  };

  const handleShowAdminDetail = () => {
    SlideManager.show({
      body: <AIReviewDetailAdminViewerTemplate review={review} onDeleteReview={() => {}} />,
      width: "800px",
    });
  };

  const content = (
    <AIReviewDetailTemplate
      review={review}
      evaluation={evaluation}
      onAdminDetail={handleShowAdminDetail}
    />
  );

  return (
    <PopupContainer>
      <Header>
        <Title>
          AI Review #{review.id}
        </Title>
        <CloseButton onClick={handleClose}>✕</CloseButton>
      </Header>
      <ContentWrapper>
        {review.feedback ? (
          <AdminFeedbackProvider feedback={review.feedback}>
            {content}
          </AdminFeedbackProvider>
        ) : (
          content
        )}
      </ContentWrapper>
    </PopupContainer>
  );
};

export default AdminAIReviewDetailPopupTemplate;